module.exports = __webpack_public_path__ + "img/advanceUp.dcff68ee.svg";